module.exports = __webpack_public_path__ + "img/shiba-loading.c3a1143b.gif";